import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import GenerateAccountsSection from 'features/admin/sections/GenerateAccountsSection';

type Props = {}

const GenerateAccounts = (props: Props) => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // render
  return (
    <>
      <Header
          title={tLabels("generateAccounts.title")}
          subtitle={tLabels("generateAccounts.subtitle")}
          includeBreadcrumbs
      />
      <ModuleContent>
        <GenerateAccountsSection />
      </ModuleContent>
    </>
  )
}

export default GenerateAccounts;